import { ROUTE_PATH as QUESTIONS_PAGE_PATH } from '@/features/questionsPage/consts';

export const ROUTE_PATH = `${QUESTIONS_PAGE_PATH}/:questionId/edit`;

export const FEATURE_NAME = 'questionEditPage';
